export enum LendType {
  LEND = 'LEND',
  UNLEND = 'UNLEND',
}
